// translations.service.ts
import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TranslationsService {
  private currentLanguageSubject: BehaviorSubject<string>;
  public currentLanguage: Observable<string>;

  public translationsLoaded = new EventEmitter<boolean>();

    constructor(
      private http: HttpClient
    ) {
    this.currentLanguageSubject = new BehaviorSubject<string>(localStorage.getItem('locale') || 'en');
    this.currentLanguage = this.currentLanguageSubject.asObservable();
    this.loadTranslations();
  }

  loadTranslations(): void {
    const lang = this.currentLanguageSubject.getValue();
    this.http.get(`/assets/i18n/${lang}.json`).subscribe(data => {
      environment.translations = data;
      if (lang != localStorage.getItem("locale")) {
        localStorage.setItem('locale', lang);
        window.location.reload();
      }
    });
  }

  translate(key: string): string {
    return environment.translations[key] || key;
  }

  changeLanguage(lang: string): void {
    this.currentLanguageSubject.next(lang);
    this.loadTranslations();
  }
}
